import React, { Component } from 'react';
import './../../assets/css/App.css';
import Service from './service';
import Table from './../../component/table/table/Table';
import TableRowColumn from './../../component/table/table/TableRowColumn';
import TableHead from './../../component/table/table/TableHead';
import TableHeaderColumn from './../../component/table/table/TableHeaderColumn';
import TableBody from './../../component/table/table/TableBody';
import TableSearchHeader from './../../component/table/table/TableSearchHeader';
import TablePagination from './../../component/table/pagination';
import utils from './../../component/utils/utils';
import _ from 'underscore';

class TableView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        tableHeaderTitle: "New Sign Ups per day",
        pagingMetadata: [],
        responseTableData: {}
    }

    constructor() {
        super();
        // setting default attribute values
        this.headerProps = {
            headerName: "Dashboard Page"
        };
        this.currentPage = 0;
        this.searchFieldValuesObject = {};
        this.selectDropdownloIntervalValuesForThreeMonth = utils.selectDropdownloIntervalValuesForThreeMonth;
        this.sortBy = "";
        this.orderType = "";
    }

    componentDidMount () {
        Service.event.onFetchSignUpStatsPerDayTableData.add((data) => {
            this.setState({
                responseTableData: data,
                pagingMetadata: data.pagingMetadata
            });
        });
    }

    // refresh button actions
    searchButtonAction = (selectedSignUpsInterval) => {
        Service.fetchSignUpStatsPerDay(selectedSignUpsInterval, 'table');
    };

    jumpToPage = (e) => {
        e.preventDefault();
        var page = e.currentTarget.attributes.getNamedItem('data-page').value;
        this.currentPage = Number(page);
        this._callServiceFetch(page);
    };

    goForwardToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 0) {
            this.currentPage = this.currentPage + 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    goBackToPage = (e) => {
        e.preventDefault();
        if (this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this._callServiceFetch(this.currentPage);
        }
    };

    jumpToFirstPage = (e) => {
        e.preventDefault();
        this.currentPage = 1;
        this._callServiceFetch(1);
    };

    jumpToLastPage = (e) => {
        e.preventDefault();
        this.currentPage = Number(this.state.pagingMetadata.pageCount);
        this._callServiceFetch(this.currentPage);
    };

    createTableRowColumns = () => {
        var rowColumnComponentList = [];
        if (this.state.responseTableData.results !== undefined) {
            rowColumnComponentList = this.state.responseTableData.results.map(function(item, index) {
                var rowColumnComponent = {};
                rowColumnComponent = <tr key={index}>
                    <TableRowColumn>{item.accountCreationDate}</TableRowColumn>
                    <TableRowColumn>{item.countSignUpPerDate}</TableRowColumn>
                </tr>
                return rowColumnComponent;
            });
        } else {
            rowColumnComponentList.push(<tr key="0"><td colSpan="8">{this.state.emptyTableMessage}</td></tr>);
        }
        return rowColumnComponentList;
    };

    sortColumnHandler = (e) =>{
        if (this.state.responseTableData.results) {
            let sortByAttr = "";
            var sortedList = [];
            sortByAttr = e.currentTarget.attributes.getNamedItem("id").value;

            var responseTableDataTemp = this.state.responseTableData;
            sortedList = _.sortBy(this.state.responseTableData.results, sortByAttr);

            if (this.orderType === "" || this.orderType === "desc") {
                sortedList = _.sortBy(this.state.responseTableData.results, sortByAttr);
                this.orderType = "asc";
            } else if (this.orderType === "asc") {
                sortedList = sortedList.reverse();
                this.orderType = "desc";
            }

            responseTableDataTemp.results = sortedList;

            this.setState({
                responseTableData: responseTableDataTemp,
            });
        }
    };

    render() {
        return (
            <div>
                <Table>
                    <TableSearchHeader
                        headerClassName = {"fa fa-credit-card"}
                        tableHeaderTitle = {this.state.tableHeaderTitle}
                        searchButtonAction = {this.searchButtonAction}
                        selectDropdownValues = {this.selectDropdownloIntervalValuesForThreeMonth}
                    ></TableSearchHeader>
                   <TableHead>
                       <tr>
                           <TableHeaderColumn>Date</TableHeaderColumn>
                           <TableHeaderColumn id='countSignUpPerDate' onClick={this.sortColumnHandler} className="table-header-column-pointer">Number of Sign Ups
                               <span className = { (this.orderType === 'asc') ? "fa fa-caret-up":"fa fa-caret-down"}/>
                           </TableHeaderColumn>
                       </tr>
                   </TableHead>
                   <TableBody>
                           {this.createTableRowColumns()}
                   </TableBody>
                    <TablePagination
                        pagingMetadata={this.state.pagingMetadata}
                        jumpToPage={this.jumpToPage}
                        goForwardToPage={this.goForwardToPage}
                        goBackToPage={this.goBackToPage}
                        jumpToFirstPage={this.jumpToFirstPage}
                        jumpToLastPage={this.jumpToLastPage}>
                    </TablePagination>
                </Table>
            </div>
        );
    }
}

export default TableView;